import { RecordStore, StoreState } from '@deqo/foundation';
import { BoardParticipantData } from '../../../api/ApiTypes';
import { Colors } from './../../../ui';

// export const BadgeColors = {
//     0: '#18294f',
//     1: '#36d484',
//     2: '#7d6dfb',
//     3: '#fec541',
//     4: '#fc5a7d',
//     5: '#32ccf4',
//     6: '#fd9252',
//     7: '#787878',
//     8: '#a5be00',
//     9: '#bb342f',
//     10: '#b4adea',
//     11: '#768948',
//     12: '#fe4a49',
//     13: '#ec9f05',
//     14: '#207f4f',
//     15: '#fb9f89',
//     16: '#987627',
//     17: '#97364b',
//     18: '#1e7a92',
//     19: '#975731',
// };

export type ParticipantPresence = 'offline' | 'away' | 'active';

const initialState = {
    id: '',
    name: '',
    email: '',
    photo: '',
    color: Colors.primary,
    handwriting: 'Kalam',
    hat: '',
    presence: 'offline' as ParticipantPresence,
    self: false,
    joined: false,
    loaded: false,
    lastSeenAt: new Date('1970-01-01'),
    createdAt: new Date('1970-01-01'),
};

const presenceWeight = {
    'active': 0,
    'away': 1,
    'offline': 2,
};

export interface ParticipantPatch {
    name?: string;
    photo?: string;
    color?: string;
    handwriting?: string;
    hat?: string;
    presence?: ParticipantPresence;
    joined?: boolean;
    lastSeenAt?: Date;
}

export class Participant extends RecordStore(initialState) {

    public static readonly anonymous = new Participant({
        id: 'US???',
        name: 'Anonymous User',
        email: 'anonymous@ludi.co',
        photo: 'deqo://icons/i8/qmark',
        color: Colors.observe,
        handwriting: 'Kalam',
        joined: false,
        loaded: false,
        lastSeenAt: new Date(1970),
        createdAt: new Date(1970),
    }, false);

    public static readonly unknown = new Participant({
        id: 'US0000NULL',
        name: 'Unknown User',
        email: 'unknown@ludi.co',
        photo: 'deqo://icons/i8/qmark',
        color: Colors.primary,
        handwriting: 'Kalam',
        joined: false,
        loaded: false,
        lastSeenAt: new Date(1970),
        createdAt: new Date(1970),
    }, false);

    public static shell(id: string) {
        return new Participant({
            id,
            name: 'Loading',
            email: 'loading@ludi.co',
            photo: 'deqo://icons/i8/qmark',
            color: Colors.observe,
            handwriting: 'Kalam',
            joined: false,
            loaded: false,
            lastSeenAt: new Date(1970),
            createdAt: new Date(1970),
        }, false);
    }

    public static createSorter(weightSelf = true) {
        return (a: Participant, b: Participant) => {
            if (weightSelf) {
                if (a.self) return -1;
                if (b.self) return 1;
            }
            if (a.presence !== b.presence) {
                return presenceWeight[a.presence] - presenceWeight[b.presence];
            }
            if (a.name !== b.name) {
                return a.name.localeCompare(b.name);
            }
            else {
                return a.id.localeCompare(b.id);
            }
        };
    }

    public static toInitials(name?: string) {
        if (!name || !name.length) return '';
        if (name.length === 2) return name;
        const [first, last] = name.toUpperCase().split(' ').map(x => x.trim());
        let i = (first[0] || '');
        if (!!last) i += last[0];
        return i;
    }

    constructor(protected ptptData: BoardParticipantData & { loaded: boolean }, self: boolean) {
        super();
        this.updateState({ self, ...ptptData });
    }

    public update(patch: ParticipantPatch) {
        this.updateState(patch);
    }
}

export type ParticipantData = StoreState<Participant>;
